import { useEffect, useState } from "react";
import { X, Download, Share } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";
import { LogoMark } from "./Logo";

export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [visible, setVisible] = useState(false);
  const [ios, setIos] = useState(false);

  useEffect(() => {
    if (window.matchMedia("(display-mode: standalone)").matches) return;
    if (localStorage.getItem("cn_install_dismissed")) return;
    const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent);
    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
      setVisible(true);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);
    if (isIOS && !navigator.standalone) {
      setIos(true);
      setVisible(true);
    }
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice.catch(() => null);
    setVisible(false);
    localStorage.setItem("cn_install_dismissed", "1");
  };

  const dismiss = () => {
    setVisible(false);
    localStorage.setItem("cn_install_dismissed", "1");
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 30 }}
          transition={{ duration: 0.35, ease: "easeOut" }}
          className="lg:hidden fixed left-4 right-4 z-[60]"
          style={{ bottom: "164px" }}
          data-testid="install-prompt"
        >
          <div className="card-gold hover:!transform-none flex items-center gap-3 p-4 border-[rgba(212,175,55,0.45)]">
            <LogoMark size={34} />
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-white">Install CREDNOVA App</p>
              <p className="text-[11px] text-[#A1A1AA] truncate">
                {ios ? "Tap Share, then 'Add to Home Screen'" : "Quick access from your home screen"}
              </p>
            </div>
            {!ios && (
              <button
                onClick={install}
                data-testid="install-prompt-button"
                className="btn-gold rounded-full px-4 py-2 text-xs shrink-0"
              >
                <span className="relative z-10 flex items-center gap-1.5">
                  <Download size={13} /> Install
                </span>
              </button>
            )}
            {ios && <Share size={16} className="text-[#D4AF37] shrink-0" />}
            <button
              onClick={dismiss}
              data-testid="install-prompt-dismiss"
              aria-label="Dismiss install prompt"
              className="text-[#71717A] hover:text-[#A1A1AA] p-1 shrink-0"
            >
              <X size={16} />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
